import Swiper from 'swiper'
import { Navigation, Scrollbar, Keyboard } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

export default (desktopSlidesPerView = 5, mobileSlidesPerView = 2) => ({
    init() {
        const slider = this.$root.querySelector('.swiper')

        const swiper = new Swiper(slider, {
            modules: [Navigation, Scrollbar, Keyboard],
            slidesPerView: mobileSlidesPerView,
            spaceBetween: 8,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: desktopSlidesPerView,
                    spaceBetween: 40,
                },
            },
        })
    },
})
